export const AppRoutes = {
  BASENAME: "/documentation-explorer",
  ROOT: "/",
  HOME: "/home",
  CATALOG: "/docs",
  SEARCH: "/search",
  DOC: "/docs/:id",
  NEW: "/docs/new",
  EDIT: "/docs/:id/edit",
  LOGIN: "/",
} as const;
